var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-6 container-background", attrs: { fluid: "" } },
    [
      _c("v-card", { staticClass: "main-card pa-6 mb-6" }, [
        _c(
          "div",
          {
            staticClass: "d-flex align-center justify-space-between flex-wrap",
          },
          [
            _c("div", [
              _c(
                "h1",
                { staticClass: "main-title" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "rgb(204 33 40)" } },
                    [_vm._v(" mdi-qrcode ")]
                  ),
                  _vm._v(" Publicación y código QR "),
                ],
                1
              ),
              _c("p", { staticClass: "main-subtitle" }, [
                _vm._v(
                  " Utilice el código QR o el enlace único para que sus clientes puedan autogestionar el registro y consentimiento de Habeas Data. "
                ),
              ]),
            ]),
          ]
        ),
      ]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "7" } },
            [
              _c(
                "v-card",
                { staticClass: "section-card pa-6" },
                [
                  _c("div", { staticClass: "section-header" }, [
                    _c(
                      "div",
                      { staticClass: "section-icon" },
                      [
                        _c("v-icon", { attrs: { color: "white" } }, [
                          _vm._v(" mdi-qrcode-scan "),
                        ]),
                      ],
                      1
                    ),
                    _c("div", [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(" Configuración QR "),
                      ]),
                      _c("p", { staticClass: "section-subtitle" }, [
                        _vm._v(
                          " Personalice el contenido visual del código QR. "
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "mt-6",
                      model: {
                        value: _vm.formValid,
                        callback: function ($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("label", { staticClass: "custom-label" }, [
                            _vm._v(
                              " Ingrese el título que requiere que se imprima con el QR "
                            ),
                          ]),
                          _c("v-text-field", {
                            staticClass: "custom-input",
                            attrs: {
                              outlined: "",
                              dense: "",
                              placeholder: "Ej: Título QR",
                              rules: [_vm.rules.required],
                            },
                            model: {
                              value: _vm.formTitleQR,
                              callback: function ($$v) {
                                _vm.formTitleQR = $$v
                              },
                              expression: "formTitleQR",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-5" },
                        [
                          _c("label", { staticClass: "custom-label" }, [
                            _vm._v(
                              " Ingrese el mensaje que requiere se imprima con el QR en la parte inferior. "
                            ),
                          ]),
                          _c("v-text-field", {
                            staticClass: "custom-input",
                            attrs: {
                              outlined: "",
                              dense: "",
                              placeholder: "Ej: Escanéame para registrarte",
                              rules: [_vm.rules.required],
                            },
                            model: {
                              value: _vm.formMessageQR,
                              callback: function ($$v) {
                                _vm.formMessageQR = $$v
                              },
                              expression: "formMessageQR",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "5" } },
            [
              _c("v-card", { staticClass: "preview-card pa-6" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-center mb-4" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { color: "rgb(204 33 40)" },
                      },
                      [_vm._v(" mdi-eye-outline ")]
                    ),
                    _c("h3", { staticClass: "preview-title" }, [
                      _vm._v(" Vista previa QR "),
                    ]),
                  ],
                  1
                ),
                _c("div", { ref: "printArea", staticClass: "qr-preview" }, [
                  _c("div", { staticClass: "qr-title" }, [
                    _vm._v(" " + _vm._s(_vm.formTitleQR || "Título QR") + " "),
                  ]),
                  _c("img", {
                    staticClass: "qr-image",
                    attrs: { src: _vm.imageUrl, alt: "QR" },
                  }),
                  _c("div", { staticClass: "qr-footer" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formMessageQR || "Escanéame para registrarte"
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { staticClass: "section-card pa-6 mt-2" },
                [
                  _c("div", { staticClass: "section-header mb-5" }, [
                    _c(
                      "div",
                      { staticClass: "section-icon" },
                      [
                        _c("v-icon", { attrs: { color: "white" } }, [
                          _vm._v(" mdi-link-variant "),
                        ]),
                      ],
                      1
                    ),
                    _c("div", [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(" Enlace directo "),
                      ]),
                      _c("p", { staticClass: "section-subtitle" }, [
                        _vm._v(" Este enlace es único para su comercio. "),
                      ]),
                    ]),
                  ]),
                  _c("v-text-field", {
                    staticClass: "custom-input",
                    attrs: {
                      outlined: "",
                      readonly: "",
                      "prepend-inner-icon": "mdi-web",
                      "append-icon": "mdi-content-copy",
                      label: "URL de registro",
                    },
                    on: { "click:append": _vm.copyUrl },
                    model: {
                      value: _vm.formUrlDirect,
                      callback: function ($$v) {
                        _vm.formUrlDirect = $$v
                      },
                      expression: "formUrlDirect",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8", md: "6" } },
            [
              _vm.showAlert
                ? _c(
                    "v-alert",
                    {
                      staticClass: "my-4",
                      attrs: {
                        type: _vm.alertType,
                        border: "left",
                        "colored-border": "",
                        elevation: "2",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-end mt-4" },
        [
          _c(
            "v-btn",
            {
              staticClass: "white--text px-10 font-weight-bold",
              attrs: {
                color: "rgb(204 33 40)",
                "x-large": "",
                elevation: "2",
                rounded: "",
              },
              on: { click: _vm.save },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v(" mdi-printer-outline "),
              ]),
              _vm._v(" Guardar e imprimir QR "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.6", "z-index": "9999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }